<template>
  <div class="invoice-advance-dialog">
    <custom-dialog width="1200px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <div class="search-hd">
          <el-form :inline="true" @submit.native.prevent>
            <!-- 配置项 -->
            <el-form-item style="float: right; margin-right: 0">
              <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
            </el-form-item>
            <el-form-item style="float: right">
              <search-input v-model="formSearch.search" :placeholder="$t('dms_product_addProtocol_dialog.xybmxymc')" @fetch="onPageChange({ page: 1 })"></search-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-bd">
          <custom-table :data="protocolList" height="600px" type="checkbox" :column="tableColumn" @input="selectionChange" @filter="filterChange" @sort="sortChange"></custom-table>
        </div>
        <div class="table-page">
          <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">
          {{ $t('Common.com_cancel') }}
        </el-button>
        <el-button type="primary" @click="saveProtocol">
          {{ $t('Common.com_confirm') }}
        </el-button>
      </div>
    </custom-dialog>

    <!-- 图片预览 -->
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      visible: true,
      tableCode: 'product_protocol_add',
      formSearch: {
        productSn: '',
        search: '',
        pageSize: 20,
        pageNum: 1,
        protocolType: [2, 3],
        // isAssociated: 0, // 0未关联 1已关联
        firmwareId: '',
        productCodes: '',
      },
      productCodeslist: [],
      isLoading: false,
      totalRows: null,
      protocolList: [],
    };
  },
  mounted() {
    this.initDialog();
    this.getTableColumn();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.formSearch.productSn = this.model.productSn;
      this.getProtocolList();
    },
    getProtocolList: function () {
      this.$getJSON(apis.productProtocolSelectList, this.formSearch).then((res) => {
        this.isLoading = false;
        this.protocolList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 保存编辑分组
    saveProtocol: function () {
      if (!this.tableSelect.length) {
        this.$message.error(this.$t('dms_product_addProtocol_dialog.xuan_ze_xie_yi'));
      }
      // 协议类别不能重复
      const protocolClassArr = [];
      const hasCodeRepeat = this.tableSelect.find((item) => {
        let res;
        if (protocolClassArr.length > 0) {
          res = protocolClassArr.find(pitem => item.protocolClass === pitem.protocolClass);
        }
        protocolClassArr.push(item);
        return res;
      });
      if (hasCodeRepeat) {
        const tips = this.$t('dms_product_addProtocol_dialog.xylbbncf');
        this.$message.error(tips);
        return;
      }
      const ids = this.tableSelect.map(t => t.protocolCode);
      this.$postJSON(
        apis.productProtocolBinding,
        {
          productSn: this.model.productSn,
          protocolCodes: ids,
        },
        true
      ).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getProtocolList();
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';
.invoice-advance-dialog {
  .dialog-body {
    .table-bd {
      height: auto !important;
    }
  }
}
</style>
